import { DataSourceEndPoints, pageNo } from "../../config";
import { getQueryStringFrmObject, postApi, getApi } from "../helpers/utility";

class DataSourceApi {
  create = async (dataSourcePojo) => {
    console.log("dataSourcepojo", dataSourcePojo);
    if (dataSourcePojo) {
      //   console.log("DataSource pojo", JSON.stringify(dataSourcePojo));
      var result = await postApi(DataSourceEndPoints.add, dataSourcePojo);
      return result;
    }
  };

  read = async (readFilter, page) => {
    let finalListEndPoint;
    finalListEndPoint = DataSourceEndPoints.list + "?pageNo=" + page + "&per_page=" + pageNo;
    let searchParams = { info: readFilter };
    if (searchParams.info) {
      var queryString = getQueryStringFrmObject(searchParams);
      finalListEndPoint = finalListEndPoint + "&" + queryString;
    }
    var result = await getApi(finalListEndPoint);
    return result;
  };

  findById = async (dataSourceId) => {
    var result = await getApi(DataSourceEndPoints.findById, dataSourceId);
    return result;
  };
}
export default new DataSourceApi();
